<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.stop="showSearch(true)" depressed>検索ダイアログ表示</v-btn>
      </section>

      <v-card flat>
        <v-row>
          <v-col cols="12" sm="5">
            <v-sheet id="tree-view">
              <v-treeview 
                :items="filterDialys"
                :active.sync="active"
                activatable transition>
                <template v-slot:prepend="{ item }">
                  <v-icon>{{ item.file }}</v-icon>
                </template>
                <template v-slot:label="{ item }">
                  <span :class="item.class ? item.class : ''">{{ item.name }}</span>
                </template>
              </v-treeview>
            </v-sheet>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col>
            <v-sheet>
              <template v-if="selected.dialys && selected.dialys.length > 0">
                
                <div class="d-flex">
                  <v-spacer></v-spacer>
                  <template v-if="isApproval && isJudge">
                    <v-btn color="warning" @click.stop="approval" depressed>
                      <v-icon left>far fa-calendar-check</v-icon>
                      <template v-if="selected.dialys.length > 1">まとめて</template>承認する
                    </v-btn>
                  </template>
                  <template v-if="isRelease">
                    <v-btn color="error" @click.stop="release" depressed>
                      <v-icon left>far fa-calendar-times</v-icon>
                      承認解除する
                    </v-btn>
                  </template>
                </div>
              </template>
                
              <template v-if="selected.user">
                <v-simple-table class="data-table">
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <th>担当者</th>
                        <td>{{ selected.user.last + ' ' + selected.user.first }}</td>
                      </tr>
                      <tr>
                        <th>部署</th>
                        <td>{{ selected.user.department }}</td>
                      </tr>
                      <tr>
                        <th>期間</th>
                        <td>{{ selected.span }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-tabs
                  v-model="tab"
                  class="mb-5"
                  grow>
                  <v-tabs-slider color="orange"></v-tabs-slider>
                  <v-tab>集計データ</v-tab>
                  <v-tab>日別作業</v-tab>
                </v-tabs>
              </template>
              <v-tabs-items id="detail-view" v-model="tab">
                <!-- 集計データ -->
                <v-tab-item>
                  <template v-if="selected.summary">
                    <div class="section-title">就業時間集計</div>
                    <v-simple-table class="data-table">
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <th>通常</th>
                            <td>
                              {{ selected.summary.totalTime }}
                              <template v-if="selected.type == 'week' && overWork > 0">
                                <span class="red--text">(+{{ overWork }})</span>
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <th>残業</th>
                            <td>{{ selected.summary.overTime }}</td>
                          </tr>
                          <tr>
                            <th>深夜</th>
                            <td>{{ selected.summary.midnightTime }}</td>
                          </tr>
                          <tr>
                            <th>休日</th>
                            <td>{{ selected.summary.holidayTime }}</td>
                          </tr>
                          <tr>
                            <th>休日深夜</th>
                            <td>{{ selected.summary.holidayMignightTime }}</td>
                          </tr>
                          <tr>
                            <th>法定休日</th>
                            <td>{{ selected.summary.legalHolidayTime }}</td>
                          </tr>
                          <tr>
                            <th>法定休日深夜</th>
                            <td>{{ selected.summary.legalHolidayMignightTime }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <div class="section-title">労務情報</div>
                    <v-simple-table class="data-table">
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <th>代休</th>
                            <td>
                              {{ selected.summary.instead.time }} h
                              <template v-if="selected.summary.instead.days.length > 0">
                                <br>[ {{ selected.summary.instead.days.join(' / ') }} ]
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <th>振休</th>
                            <td>
                              {{ selected.summary.transfer.time }} h
                              <template v-if="selected.summary.transfer.days.length > 0">
                                <br>[ {{ selected.summary.transfer.days.join(' / ') }} ]
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <th>有給</th>
                            <td>
                              {{ selected.summary.paid.time }} h
                              <template v-if="selected.summary.paid.days.length > 0">
                                <br>[ {{ selected.summary.paid.days.join(' / ') }} ]
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <th>欠勤</th>
                            <td>
                              {{ selected.summary.absence.time }} h
                              <template v-if="selected.summary.absence.days.length > 0">
                                <br>[ {{ selected.summary.absence.days.join(' / ') }} ]
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </template>
                  <template v-if="selected.works">
                    <div class="section-title">管理費集計</div>
                    <v-simple-table class="data-table">
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="(item, index) in selected.works" :key="index">
                            <td>{{ item.project }}</td>
                            <td>
                              <template v-if="item.workList">
                                <ul class="list-unstyled">
                                  <li v-for="work in item.workList" :key="work.worktypeID">
                                    <span class="worktype">{{ work.worktype }}</span>
                                    <span class="worksum">{{ work.sum.toFixed(2) }}</span>
                                  </li>
                                </ul>
                              </template>
                            </td>
                            <td>{{ item.sum.toFixed(2) }}</td>
                            <td>
                              <template v-if="selected.user.unitPrice">
                                x @{{ separate(selected.user.unitPrice) }} = {{ separate(item.sum * selected.user.unitPrice) }}
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </template>
                </v-tab-item>
                <!-- 日別作業 -->
                <v-tab-item>
                  <div class="d-flex">
                    <v-spacer></v-spacer>
                    <vue-excel-xlsx
                      :data="daysData"
                      :columns="daysColumn"
                      :file-name="daysFileName"
                      file-type="xlsx"
                      class="mr-3">
                      <v-btn small depressed>
                        <v-icon left>fas fa-file-download</v-icon>
                        ダウンロード
                      </v-btn>
                    </vue-excel-xlsx>
                  </div>
                  <v-simple-table class="data-table">
                    <thead>
                      <tr>
                        <th>日付</th>
                        <th>作業内容</th>
                        <th>通常</th>
                        <th>残業</th>
                        <th>深夜</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="day in days" :key="day">
                        <th>
                          <span :class="isHoliday(day) ? 'red--text' : ''">{{ getDateString(day) }}</span>
                        </th>
                        <template v-if="getWorks(day)">
                          <td>
                            <ul class="list-unstyled">
                              <li v-for="item in getWorks(day)" :key="item.id">
                                <span class="project">{{ getProject(item.projectID) }}</span>
                                <span class="worktype">{{ getWorktype(item.worktypeID) }}</span>
                                <span class="time">{{ unixToTime(item.start) }} ～ {{ unixToTime(item.end) }}</span>
                              </li>
                            </ul>
                          </td>
                          <td>{{ getOvertime(day).totalTime }}</td>
                          <td>{{ getOvertime(day).overTime }}</td>
                          <td>{{ getOvertime(day).midnightTime }}</td>
                        </template>
                        <template v-else>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </template>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-tab-item>
              </v-tabs-items>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card>

      <!-- 編集ダイアログ -->
      <v-navigation-drawer v-model="dialog" fixed temporary right stateless width="600" id="dialog" class="edit-dialog">
        <v-card flat class="drawer-card">
          <v-card-title class="dialog-header">
            <span class="title font-weight-light">検索条件を指定</span>
          </v-card-title>
          <v-card-text class="scroll-content">
            <v-form v-model="valid">
              <section class="accordion_inner">
                <v-row no-gutters>
                  <v-col cols="6" class="pa-2">
                    <v-combobox
                      ref="project"
                      label="案件"
                      v-model="editedItem.project"
                      :items="projectItems"
                      append-icon="fas fa-list-ol"
                      @click.stop="openSelected('project')"
                      readonly outlined clearable hide-details="auto">
                    </v-combobox>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-combobox
                      ref="worktype"
                      label="作業種別"
                      v-model="editedItem.worktype"
                      :items="worktypeItems"
                      append-icon="fas fa-list-ol"
                      @click.stop="openSelected('worktype')"
                      readonly outlined clearable hide-details="auto">
                    </v-combobox>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-combobox
                      ref="department"
                      label="所属部署"
                      v-model="editedItem.department"
                      :items="departmentItems"
                      append-icon="fas fa-list-ol"
                      @click.stop="openSelected('department')"
                      readonly outlined clearable hide-details="auto">
                    </v-combobox>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-combobox
                      ref="user"
                      label="担当者"
                      v-model="editedItem.user"
                      :items="userItems"
                      append-icon="fas fa-list-ol"
                      @click.stop="openSelected('user')"
                      readonly outlined clearable hide-details="auto">
                    </v-combobox>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-combobox
                      ref="quickSpan"
                      label="期間プリセット"
                      v-model="searchSpan"
                      :items="spanList"
                      append-icon="fas fa-list-ol"
                      @click.stop="openSelected('quickSpan')"
                      readonly outlined hide-details="auto">
                    </v-combobox>
                  </v-col>
                  <v-col cols="6" class="pa-2">
                    <v-menu
                      v-model="span"
                      :close-on-content-click="false"
                      :nudge-right="0"
                      transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          ref="customeSpan"
                          label="期間を任意指定"
                          :value="spanText"
                          v-on="on"
                          @click:clear="editedItem.span = []"
                          outlined hide-details="auto">
                        </v-text-field>
                      </template>
                      <v-date-picker 
                        v-model="editedItem.span" 
                        :title-date-format="spanFunc"
                        range></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </section>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click.stop="search" :loading="loading" text x-large>
              <v-icon left>fas fa-search</v-icon>検索する
            </v-btn>
            <v-btn @click="dialog = false" text x-large>
              <v-icon left>fas fa-times</v-icon>閉じる
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-navigation-drawer>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { updateDialy, updateUser } from '../graphql/mutations'
import { 
  listAppOptions, listDialies, listProjects,
  listWorkTypes, listUsers, listEvents, listWorkTimeGroups, getWorkTimeGroup } from '../graphql/queries'
import { 
  onUpdateDialy,
  onCreateProject, onUpdateProject, onDeleteProject,
  onCreateEvent, onUpdateEvent, onDeleteEvent } from '../graphql/subscriptions'
import moment from 'moment'

export default {
  data() {
    return {
      loading: false,
      dialog: true,
      valid: false,
      saving: false,
      dialys: [
        {
          name: '検索結果',
          file: 'fas fa-search',
          children: [],
        }
      ],
      projects: [],
      worktypes: [],
      worktimes: [],
      users: [],
      events: [],
      appOptions: {},
      editedIndex: -1,
      editedItem: {
        span: [],
      },
      searchKeyword: {},
      span: false,
      summaryData: [],
      active: [],
      selected: {},
      spanPreset: [],
      searchSpan: null,
      tab: null,
      daysColumn: [
        { label: '日付', field: 'day' },
        { label: '作業内容', field: 'work' },
        { label: '通常', field: 'totalTime' },
        { label: '残業', field: 'overTime' },
        { label: '深夜', field: 'midnightTime' },
      ]
    }
  },
  prop: {},
  mounted: async function() {
    //設定 query
    const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 100 }))
    for (const row of appOptionQuery.data.listAppOptions.items) {
      this.appOptions[row.name] = row.value
    }
    //締め日が設定されていれば期間を自動設定
    if (this.appOptions.closing && this.appOptions.closing != '0') {
      const day = parseInt(this.appOptions.closing)
      let from, to
      
      if (day >= moment().date()) {
        from = moment().subtract(1, 'months').date(day).add(1, 'days')
        to = moment().date(day)

      } else {
        from = moment().date(day).add(1, 'days')
        to = moment().add(1, 'months').date(day)
      }
      
      this.searchKeyword.span = [
        from.format('YYYY-MM-DD'),
        to.format('YYYY-MM-DD')
      ]

      for (let i=0; i<12; i++) {
        this.spanPreset.push({
          dateStr: moment(to).subtract(i, 'month').format('YYYY年M月'),
          dateSpan: {
            from: moment(from).subtract(i, 'month').format('YYYY-MM-DD'),
            to: moment(to).subtract(i, 'month').format('YYYY-MM-DD')
          }
        })
      }

    //締め日未設定の場合は月初～月末
    } else {
      let from, to

      from = moment().startOf('month')
      to = moment().endOf('month')

      this.searchKeyword.span = [
        from.format('YYYY-MM-DD'),
        to.format('YYYY-MM-DD')
      ]

      for (let i=0; i<12; i++) {
        this.spanPreset.push({
          dateStr: moment(to).subtract(i, 'month').format('YYYY年M月'),
          dateSpan: {
            from: moment(from).subtract(i, 'month').startOf('month').format('YYYY-MM-DD'),
            to: moment(to).subtract(i, 'month').endOf('month').format('YYYY-MM-DD')
          }
        })
      }
    }

    this.searchSpan = this.spanList[0]

    //プロジェクト query
    await this.getProjects()
    //ユーザー query
    await this.getUsers()
    //作業種別 query
    await this.getWorkTypes()
    //労務・休憩時間 query
    await this.getWorkTimeGroups()
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateDialy)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateDialy
        for (const user of this.dialys[0].children) {
          for (const week of user.children) {
            week.children.find(origin => {
              if (origin.dialyID === row.id) {
                origin.probate = row.probate
                origin.class = row.probate ? 'probated' : ''
              }
            })
          }
        }
      }
    })
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateProject
        this.projects.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateProject
        this.projects.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteProject)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteProject
        this.projects = this.projects.filter(origin => origin.id !== row.id)
      }
    })
    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateEvent
        this.events.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateEvent
        this.events.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteEvent)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteEvent
        this.events = this.events.filter(origin => origin.id !== row.id)
      }
    })
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
    
  },
  computed: {
    projectItems() {
      const map = []
      for (const item of this.projects) {
        map.push({
          value: item.id,
          text: item.code ? item.code : item.name,
        })
      }
      //コード順でソート
      map.sort(function(a,b) {
        if (a.code < b.code) return -1
        if (a.code > b.code) return 1
        return 0
      })
      return map
    },
    worktypeItems() {
      const map = []
      for (const item of this.worktypes) {
        let text = ''
        if (item.code) text += '[ ' + item.code + ' ] '
        if (item.name) text += item.name
        map.push({
          value: item.id,
          text: text,
          code: item.code ? item.code : item.name,
          name: item.name,
        })
      }
      //コード順でソート
      map.sort(function(a,b) {
        if (a.code < b.code) return -1
        if (a.code > b.code) return 1
        return 0
      })
      return map
    },
    departmentItems() {
      const map = []
      for (const item of this.users) {
        if (item.department && !map.find(e => e == item.department)) map.push(item.department)
      }
      //名前順でソート
      map.sort(function(a,b) {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      return map
    },
    userItems() {
      const map = []
      for (const item of this.users) {
        map.push({
          value: item.id,
          text: item.last + ' ' + item.first,
        })
      }
      //名前順でソート
      map.sort(function(a,b) {
        if (a.text < b.text) return -1
        if (a.text > b.text) return 1
        return 0
      })
      return map
    },
    spanText() {
      let date = this.editedItem.span ? this.editedItem.span : []
      date.sort(function(a,b) {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      return date.length > 0 ? date.join(' ～ ') : null
    },
    //承認可能か
    isApproval() {
      if (this.selected) {
        //承認する日報があるか
        for (const item of this.selected.dialys) {
          if (!item.probate) return true
        }
      }
      
      return false
    },
    //承認解除可能か
    isRelease() {
      const my = this.getMyself()

      if (this.selected && this.selected.dialys.length == 1 && my.role.find(e => e == '管理者')) {
        return this.selected.dialys[0].probate ? true : false
      }
      
      return false
    },
    isJudge() {
      const my = this.getMyself()

      if (this.selected) {
        // 対象が管理者の場合、承認可
        if (my.role.find(e => e == '管理者')) {
          return true
        
        // 対象がリーダーの場合、管理者のみ承認可
        } else if (this.selected.user.role.find(e => e == 'リーダー')) {
          return my.role.find(e => e == '管理者') ? true : false

        // 対象が社員の場合、所属部署のリーダーのみ承認可
        } else if (this.selected.user.role.find(e => e == '社員')) {
          return my.role.find(e => e == 'リーダー') && my.department == this.selected.user.department ? true : false
        }
      }
      
      return false
    },
    spanList() {
      const map = []
      for (const item of this.spanPreset) {
        map.push(item.dateStr)
      }
      return map
    },
    overWork() {
      const max = 40
      if (this.selected && this.selected.summary) {
        return this.selected.summary.totalTime > max ? this.selected.summary.totalTime - max : 0
      }
      return 0
    },
    days() {
      const map = []

      if (this.selected.start) {
        const from = this.selected.start
        const to = this.selected.end || this.selected.start
        let i = 0
        let day
        while (day != to) {
          day = moment(from, 'YYYY-MM-DD').add(i, 'days').format('YYYY-MM-DD')
          map.push(day)
          i++
        }
      }

      return map
    },
    daysFileName() {
      var name = 'export'

      if (this.selected && this.selected.user) {
        name = this.selected.user.last + this.selected.user.first + '_'
        name += this.selected.span
      }

      return name
    },
    daysData() {
      const map = []

      if (this.selected.user) {
        for (const day of this.days) {
          const works = this.getWorks(day) || []
          const time = this.getOvertime(day)
          var workList = []

          for (const work of works) {
            workList.push(
              this.getProject(work.projectID) + ' ' +
              this.getWorktype(work.worktypeID) + ' ' +
              this.unixToTime(work.start) + '～' +  this.unixToTime(work.end)
            )
          }

          map.push({
            day: this.getDateString(day),
            work: workList.join('\n'),
            totalTime: time ? time.totalTime : '',
            overTime: time ? time.overTime : '',
            midnightTime: time ? time.midnightTime : '',
          })
        }
      }

      return map
    },
    filterDialys() {
      const map = JSON.parse(JSON.stringify(this.dialys))

      for (const user of map[0].children) {
        for (const week of user.children) {
          if (this.searchKeyword.span[0] && this.searchKeyword.span[1]) {
            week.children = week.children.filter(item => moment(this.searchKeyword.span[0]) <= moment(item.start) && moment(item.start) <= moment(this.searchKeyword.span[1]))
          }
        }
      }

      return map
    },
  },
  watch: {
    searchSpan(val) {
      this.editedItem.span = []
      const item = this.spanPreset.find(e => e.dateStr == val)
      this.editedItem.span.push(item.dateSpan.from)
      this.editedItem.span.push(item.dateSpan.to)
    },
    active(val) {
      if (val[0]) {
        const sp = val[0].split('_')
        const user = this.dialys[0].children.find(e => e.id === sp[0])
        const works = []
        const dialys = []
        var type = null
        var span = ''
        var start = null, end = null

        //ユーザー選択
        if (sp.length == 1) {
          for (const week of user.children) {
            for (const day of week.children) {
              works.push(day)
            }
          }
          // console.log(works)
          span = this.getDateString(this.searchKeyword.span[0])
          if (this.searchKeyword.span[1]) {
            span += ' ～ ' + this.getDateString(this.searchKeyword.span[1])
          }
          start = this.searchKeyword.span[0]
          end = this.searchKeyword.span[1]
          type = 'month'

        //週選択
        } else if (sp.length == 2) {
          const week = user.children.find(e => e.id === val[0])
          for (const day of week.children) {
            works.push(day)
          }
          span = week.name
          start = week.start
          end = week.end
          type = 'week'

        //日選択
        } else if (sp.length == 3) {
          const week = user.children.find(e => e.id === sp[0] + '_' + sp[1])
          const day = week.children.find(e => e.id === val[0])
          works.push(day)
          span = day.name
          start = day.start
          type = 'day'
        }

        const summary = {
          totalTime: 0,
          overTime: 0,
          midnightTime: 0,
          holidayTime: 0,
          holidayMignightTime: 0,
          legalHolidayTime: 0,
          legalHolidayMignightTime: 0,
          instead: {  //代休
            days: [],
            time: 0,
          },
          transfer: {  //振休
            days: [],
            time: 0,
          },
          paid: {  //有給
            days: [],
            time: 0,
          },
          absence: {  //欠勤
            days: [],
            time: 0,
          },
        }

        const items = []

        for (const work of works) {
          let sum = 0
          let overTime = 0, midnightTime = 0
          let start = null, end = null
          let holiday = false
          let legalHoliday = false

          if (moment(work.start) < moment(this.searchKeyword.span[0]) || moment(work.start) > moment(this.searchKeyword.span[1])) continue

          dialys.push({
            id: work.dialyID,
            start: work.start,
            userName: work.user.last + ' ' + work.user.first,
            probate: work.probate,
            items: work.works.items,
          })

          //作業時間のソート
          work.works.items.sort(function(a, b) {
            if (a.start < b.start) return -1
            if (a.start > b.start) return 1
          })
          //総時間
          for (const item of work.works.items) {
            if (!start) start = moment(moment(item.start, 'X').format('HH:mm'), 'HH:mm')
            end = moment(moment(item.end, 'X').format('HH:mm'), 'HH:mm')
          }
          //終業時刻が日を跨ぐか
          if (end && end.hour() == 0) end.add(1, 'days')
          
          //休日かどうか
          holiday = this.isHoliday(work.start)
          // 法定休日かどうか
          // 2025.6.25 法定休日の判断に関する改修--------------------
          if (moment(work.start).day() == 6) {
            legalHoliday = this.isLegalHoliday(works, work.start)
            // legalHoliday = true
          }

          //残業・深夜計算
          for (const item of work.works.items) {
            var calcTime = this.diffSectionTime(
              moment(item.start, 'X').format('HH:mm'),
              moment(item.end, 'X').format('HH:mm'),
              this.getWorkTimes(work.start),
            )

            // 欠勤は加算しない 2025.12.08
            const worktype = this.worktypeItems.find(w => w.value == item.worktypeID)
            if (worktype && worktype.name == '欠勤') {
              calcTime = { sum: 0, over: 0, midnight: 0 }
            }

            //通常
            sum += calcTime.sum
            //残業
            overTime += calcTime.over
            //深夜
            midnightTime += calcTime.midnight
          }

          //就業時間集計
          if (!holiday) {
            summary.totalTime += sum
            summary.overTime += overTime
            summary.midnightTime += midnightTime
          }
          if (holiday && !legalHoliday) {
            summary.holidayTime += sum + overTime
            summary.holidayMignightTime += midnightTime
          }
          if (holiday && legalHoliday) {
            summary.legalHolidayTime += sum + overTime
            summary.legalHolidayMignightTime += midnightTime
          }

          //作業集計
          for (const item of work.works.items) {
            //const find = items.find(e => e.projectID == item.projectID && e.worktypeID == item.worktypeID)
            const find = items.find(e => e.projectID == item.projectID)
            const project = this.projectItems.find(e => e.value == item.projectID)
            const worktype = this.worktypeItems.find(e => e.value == item.worktypeID)
            var time = this.diffTime(
              moment(item.start, 'X').format('HH:mm'),
              moment(item.end, 'X').format('HH:mm'),
              true, 
              this.getWorkTimes(work.start),
            )

            // 欠勤は加算しない 2025.12.08
            if (worktype && worktype.name != '欠勤') {

              if (!find) {
                items.push({
                  projectID: project.value,
                  project: project.text,
                  //worktypeID: worktype.value,
                  //worktype: worktype.text,
                  workList: [
                    {
                      worktypeID: worktype.value,
                      worktype: worktype.text,
                      name: worktype.name,
                      sum: time,
                    }
                  ],
                  sum: time,
                  start: item.start,
                  end: item.end,
                })
                
              } else {
                find.sum +=  time
                const work = find.workList.find(e => e.worktypeID == item.worktypeID)
                if (work) {
                  work.sum += time

                } else {
                  find.workList.push({
                    worktypeID: worktype.value,
                    worktype: worktype.text,
                    name: worktype.name,
                    sum: time,
                  })
                }
              }
            }

            //代休
            if (worktype.name == '代休') {
              summary.instead.days.push(work.name)
              summary.instead.time += time
            }
            //振休
            if (worktype.name == '振休') {
              summary.transfer.days.push(work.name)
              summary.transfer.time += time
            }
            //振休
            if (worktype.name == '有給') {
              summary.paid.days.push(work.name)
              summary.paid.time += time
            }
            // 欠勤
            if (worktype.name == '欠勤') {
              summary.absence.days.push(work.name)
              summary.absence.time += time
            }
          }
        }

        //作業時間のソート
        items.sort(function(a, b) {
          //プロジェクトでソート
          if (a.project !== b.project) {
            if (a.project < b.project) return -1
            if (a.project > b.project) return 1
          }
          /*
          //作業種別でソート
          if (a.worktype !== b.worktype) {
            if (a.worktype < b.worktype) return -1
            if (a.worktype > b.worktype) return 1
          }
          */
        })

        this.selected = Object.assign({}, {
          user: this.users.find(e => e.id === user.id),
          span: span,
          start: start,
          end: end,
          summary: summary,
          works: items,
          type: type,
          dialys: dialys,
        })
      
      } else {
        this.selected = {}
      }
    }
  },
  methods: {
    //初期化
    async init() {

    },
    //検索
    async search() {
      const conditions = {}
      const filter = []

      this.searchKeyword = Object.assign({}, this.editedItem)

      this.dialys = [
        {
          name: '検索結果',
          file: 'fas fa-search',
          children: [],
        }
      ]
      this.selected = {}

      this.loading = true

      //担当
      if (this.searchKeyword.user) {
        filter.push({
          userID: { eq: this.searchKeyword.user.value }
        })
      }
      //期間
      if (this.searchKeyword.span.length > 0) {
        var start = this.searchKeyword.span[0]
        if (moment(start).day() != 0) {
          start = moment(start).startOf('week').format('YYYY-MM-DD')
        }
        const end = this.searchKeyword.span[1] || this.searchKeyword.span[0]
        filter.push({
          start: { ge: moment(start).format('YYYY-MM-DD') },
        })
        filter.push({
          start:  { le: moment(end).format('YYYY-MM-DD') }
        })
      }

      if (filter.length > 0) {
        conditions.filter = { and: filter }
      }
      conditions.limit = 1000
      
      await this.getDialys(conditions)
    },
    //検索ダイアログ表示
    showSearch(value) {
      if (value) {
        this.editedItem = Object.assign({}, this.searchKeyword)
        this.dialog = true

      } else {
        this.dialog = false
      }
    },
    //承認
    async approval() {
      const prepend = this.selected.dialys.length > 1 ? 'まとめて' : ''
      if (confirm(prepend + '承認しますか？')) {
        const user = this.users.find(u => u.id == this.selected.user.id)
        var maxDaysOfPaidTime = 0
        var paidRemain = 0
        var paidHoursUsed = 0
        if (user) {
          maxDaysOfPaidTime = parseInt(this.appOptions.maxDaysOfPaidTime) * parseInt(user.dailyWorktime)
          paidRemain = user.paidRemain
          paidHoursUsed = user.paidHoursUsed
        }

        // 日報
        for (const item of this.selected.dialys) {

          if (item.probate) continue

          try {
            // 労務・休憩時間
            const workTimes = this.getWorkTimes(item.start)
            // 15:00-15:15の休憩時間を除外
            const restTimes = workTimes.filter(e => e.start !== '15:00')
            
            // 有給の場合、有給残日数を減らす
            for (const work of item.items) {
              const worktype = this.worktypes.find(w => w.id == work.worktypeID)
              if (worktype && worktype.name == '有給') {
                const time = this.diffTime(
                  moment(work.start, 'X').format('HH:mm'), 
                  moment(work.end, 'X').format('HH:mm'), 
                  true,
                  restTimes,
                )
                
                // 1日有給
                if (time >= 8) {
                  if (paidRemain > 1) {
                    paidRemain -= 1
                  } else {
                    throw new Error('有給残日数が不足しているため、承認できません')
                  }

                // 時間有給
                } else {
                  if (paidHoursUsed + Math.ceil(time) > maxDaysOfPaidTime) {
                    throw new Error('時間有給取得可能日数が最大値を超えているため、承認できません')
                  } else {
                    const calcTime = Math.ceil(time) * 0.125
                    paidRemain -= calcTime
                    paidHoursUsed += Math.ceil(time)
                  }
                }
              }
            }

            // ユーザーを更新
            await API.graphql(graphqlOperation(updateUser, {input: {
              id: user.id,
              paidRemain: paidRemain,
              paidHoursUsed: paidHoursUsed,
            }}))
            user.paidRemain = paidRemain
            user.paidHoursUsed = paidHoursUsed

            // 日報の承認
            await API.graphql(graphqlOperation(updateDialy, {input: {
              id: item.id,
              probate: true,
            }}))
            item.probate = true
            item.class = 'probated'
            this.log({ type: this.$route.name, text: '[' + item.userName + ' さんの日報 ' + item.start + ' ] を承認しました' })
          
            this.myAlert('日報を承認しました', 'success')

          } catch (error) {
            this.myAlert(error.message)
          }
        }
        
      }
    },
    //承認解除
    async release() {
      if (confirm('承認解除しますか？')) {
        const user = this.users.find(u => u.id == this.selected.user.id)
        var paidRemain = 0
        var paidHoursUsed = 0
        if (user) {
          paidRemain = user.paidRemain
          paidHoursUsed = user.paidHoursUsed
        }

        for (const item of this.selected.dialys) {

          if (!item.probate) continue

          try {
            // 労務・休憩時間
            const workTimes = this.getWorkTimes(item.start)
            // 15:00-15:15の休憩時間を除外
            const restTimes = workTimes.filter(e => e.start !== '15:00')

            // 有給がある場合、有給残日数を増やす
            for (const work of item.items) {
              const worktype = this.worktypes.find(w => w.id == work.worktypeID)
              if (worktype && worktype.name == '有給') {
                const time = this.diffTime(
                  moment(work.start, 'X').format('HH:mm'), 
                  moment(work.end, 'X').format('HH:mm'), 
                  true,
                  restTimes,
                )
                // 1日有給
                if (time >= 8) {
                  if (paidRemain > 1) {
                    paidRemain += 1
                  }

                // 時間有給
                } else {
                  const calcTime = Math.ceil(time) * 0.125
                  paidRemain += calcTime
                  paidHoursUsed -= Math.ceil(time)
                  if (paidHoursUsed < 0) paidHoursUsed = 0
                }
              }
            }
            // ユーザーを更新
            await API.graphql(graphqlOperation(updateUser, {input: {
              id: user.id,
              paidRemain: paidRemain,
              paidHoursUsed: paidHoursUsed,
            }}))
            user.paidRemain = paidRemain
            user.paidHoursUsed = paidHoursUsed

            // 日報の承認を外す
            await API.graphql(graphqlOperation(updateDialy, {input: {
              id: item.id,
              probate: false,
            }}))
            item.probate = false
            item.class = ''
            this.log({ type: this.$route.name, text: '[' + item.userName + ' さんの日報 ' + item.start + ' ] を承認解除しました' })
            this.myAlert('日報を承認解除しました', 'success')

          } catch (error) {
            this.myAlert(error.message)
          }
        }
        
      }
    },
    //アコーディオンの開閉
    switchAccordion(e) {
      const target = e.target.parentElement.nextSibling
      target.style.display = target.style.display == 'none' ? 'block' : 'none'
      e.target.classList.toggle('opened')
    },
    //期間表示
    spanFunc() {
      return this.spanText || ''
    },
    //ユーザー名
    getUserName(id) {
      const user = this.users.find(e => e.id === id)
      return user ? user.last + ' ' + user.first : null
    },
    //プロジェクト名取得
    getProject(id) {
      return this.projectItems.find(e => e.value == id).text
    },
    //作業内容のソート
    sortWorks(items) {
      const map = [...items]

      map.sort(function(a,b) {
        if (a.start < b.start) return -1
        if (a.start > b.start) return 1
        return 0
      })
      return map
    },
    //作業種別取得
    getWorktype(id) {
      return this.worktypeItems.find(e => e.value == id).text
    },
    //分→時
    minutesToHours(minutes, numFlg) {
      return numFlg ? minutes / 60 : (minutes / 60).toFixed(2)
    },
    //分→時
    timeToHours(time) {
      return moment(time, 'X').format('HH:mm')
    },
    //労務時間の取得
    getWorkTimes(date) {
      const map = []

      if (date) {
        for (const item of this.worktimes) {
          if (item.start <= date && item.end >= date) {
            return item.workTimes

          } else if (item.end >= date) {
            return item.workTimes

          } else if (item.start <= date) {
            return item.workTimes
          }
        }
      }

      return map
    },
    //時間の産出
    /*
    diffTime(start, end, numFlg = false, ) {
      const a = moment(start, 'X')
      const b = moment(end, 'X')

      if (a > b) b.add(1, 'days')

      return numFlg ? (b.unix() - a.unix()) / 60 / 60 : ((b.unix() - a.unix()) / 60 / 60).toFixed(2)
    },
    */
    //作業のフィルタ
    filterItem(work) {
      //案件
      if (this.searchKeyword.project && this.searchKeyword.project.value != work.projectID) return false
      //作業種別
      if (this.searchKeyword.worktype && this.searchKeyword.worktype.value != work.worktypeID) return false

      return true
    },
    //日報の取得
    async getDialys(conditions, nextToken = null) {
      if (nextToken) conditions.nextToken = nextToken
      const query = await API.graphql(graphqlOperation(listDialies, conditions))
      for (const data of query.data.listDialies.items) {
        //所属部署
        if (this.searchKeyword.department && this.searchKeyword.department != data.user.department) continue
        //作業内容絞り込み
        const works = this.filterWorks(data.works.items)

        if (works.length > 0) {
          data.works.items = [...works]
          const startWeek = moment(data.start).startOf('week') < moment(this.editedItem.span[0]) ?
            moment(this.editedItem.span[0]).format('YYYY-MM-DD') : moment(data.start).startOf('week').format('YYYY-MM-DD')
          const endWeek = moment(data.start).endOf('week') > moment(this.editedItem.span[1]) ?
            moment(this.editedItem.span[1]).format('YYYY-MM-DD') : moment(data.start).endOf('week').format('YYYY-MM-DD')

          const user = this.dialys[0].children.find(e => e.id === data.userID)
          data.dialyID = data.id
          data.id = data.userID + '_' + startWeek + '_' + data.id

          //ユーザーを追加済
          if (user) {
            const week = user.children.find(e => e.start === startWeek)
            //週データを追加済
            if (week) {
              week.children.push(Object.assign({
                name: this.getDateString(data.start),
                file: 'fas fa-file-alt',
                class: data.probate ? 'probated' : ''
              }, data))

            //週データを未登録
            } else {
              user.children.push({
                id: data.userID + '_' + startWeek,
                start: startWeek,
                end: endWeek,
                name: this.getDateString(startWeek) + ' ～ ' + this.getDateString(endWeek),
                file: 'fas fa-calendar-week',
                children: [
                  Object.assign({
                    name: this.getDateString(data.start),
                    file: 'fas fa-file-alt',
                    class: data.probate ? 'probated' : '',
                  }, data)
                ],
              })
            }
          
          //ユーザーを未登録
          } else {
            this.dialys[0].children.push({
              id: data.userID,
              name: data.user.last + ' ' + data.user.first,
              file: 'fas fa-user',
              children: [
                {
                  id: data.userID + '_' + startWeek,
                  start: startWeek,
                  end: endWeek,
                  name: this.getDateString(startWeek) + ' ～ ' + this.getDateString(endWeek),
                  file: 'fas fa-calendar-week',
                  children: [
                    Object.assign({
                      name: this.getDateString(data.start),
                      file: 'fas fa-file-alt',
                      type: 'day',
                      class: data.probate ? 'probated' : ''
                    }, data)
                  ],
                }
              ],
            })
          }
        }
      }
      if (query.data.listDialies.nextToken) {
        this.getDialys(conditions, query.data.listDialies.nextToken)

      } else {
        //ユーザー名でソート
        this.dialys[0].children.sort(function(a, b) {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
        })
        //週でソート
        for (const user of this.dialys[0].children) {
          user.children.sort(function(a, b) {
            if (a.start < b.start) return -1
            if (a.start > b.start) return 1
          })
          //日付でソート
          for (const week of user.children) {
            week.children.sort(function(a, b) {
              if (a.name < b.name) return -1
              if (a.name > b.name) return 1
            })
          }
        }
        const s = moment(this.editedItem.span[0]).subtract(7, 'days').format('YYYY-MM-DD')
        const e = moment(this.editedItem.span[1]).add(7, 'days').format('YYYY-MM-DD')
        //休日・イベントを取得
        await this.getEvents(s, e)

        this.dialog = false
        this.loading = false
      }
    },
    //絞り込み条件に一致するか
    filterWorks(works) {
      let map = []
      for (const work of works) {
        //案件
        if (this.searchKeyword.project && this.searchKeyword.project.value != work.projectID) continue
        //作業種別
        if (this.searchKeyword.worktype && this.searchKeyword.worktype.value != work.worktypeID) continue

        map.push(work)
      }

      return map
    },
    //指定した日付の作業内容を返す
    getWorks(dateStr) {
      const dialy = this.selected.dialys.find(e => e.start == dateStr)
      if (dialy) {
        const works = [...dialy.items]
        //開始時間でソート
        works.sort(function(a, b) {
          if (a.start < b.start) return -1
          if (a.start > b.start) return 1
        })
        return works

      } else {
        return null
      }
    },
    //指定した日付の通常・残業・深夜を返す
    getOvertime(dateStr) {
      const works = this.getWorks(dateStr)
      let start = null
      let end = null

      if (works) {
        for (const work of works) {
          //総時間
          if (!start) start = moment(moment(work.start, 'X').format('HH:mm'), 'HH:mm')
          end = moment(moment(work.end, 'X').format('HH:mm'), 'HH:mm')
        }
        //終業時刻が日を跨ぐか
        if (end && end.hour() == 0) end.add(1, 'days')

        let sum = 0
        let overTime = 0
        let midnightTime = 0

        //残業・深夜計算
        for (const item of works) {
          var time = this.diffSectionTime(
            moment(item.start, 'X').format('HH:mm'),
            moment(item.end, 'X').format('HH:mm'),
            this.getWorkTimes(dateStr),
          )
          
          // 欠勤は加算しない 2025.12.08
          const worktype = this.worktypeItems.find(w => w.value == item.worktypeID)
          if (worktype && worktype.name == '欠勤') {
            time = { sum: 0, over: 0, midnight: 0 }
          }

          //通常
          sum += time.sum
          //残業
          overTime += time.over
          //深夜
          midnightTime += time.midnight
        }

        return {
          totalTime: sum,
          overTime: overTime,
          midnightTime: midnightTime
        }
      }
    },
    // 法定休日判定
    isLegalHoliday(works, date) {
      const from = moment(date).startOf('week').format('YYYY-MM-DD')
      const to = moment(date).format('YYYY-MM-DD')
      const week = []
      // 指定期間
      for (const item of works) {
        if (moment(from) <= moment(item.start) && moment(item.start) <= moment(to)) {
          week.push(item)
        }
      }
      
      // 週7日勤務している
      if (week.length >= 7) {
        for (const day of week) {
          for (const work of day.works.items) {
            // 振休が8時間以上含まれていたら法定休日にはならない
            const worktype = this.worktypes.find(e => e.id == work.worktypeID)
            if (worktype.name == '振休' && (work.end - work.start) / 60 / 60 > 8) return false
          }
        }
        return true

      } else {
        return false
      }
    },
    //休日判定
    isHoliday(dateStr) {
      let holiday = false
      //休日かどうか
      for (const item of this.events) {
        if (moment(item.start) <= moment(dateStr) && 
            moment(item.end) >= moment(dateStr)) {
          holiday = true
          break
        }
      }
      return holiday
    },
    //日付フォーマットを返す
    getDateString(dateStr) {
      const week = ['日', '月', '火', '水', '木', '金', '土']
      const date = moment(dateStr)
      return date.format('YYYY-M-D') + ' (' + week[ date.weekday() ] + ')'
    },
    //プロジェクトの取得
    async getProjects(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listProjects, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listProjects.items) {
        this.projects.push(data)
      }
      if (query.data.listProjects.nextToken) this.getProjects(query.data.listProjects.nextToken)
    },
    //作業種別の取得
    async getWorkTypes(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTypes, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTypes.items) {
        this.worktypes.push(data)
      }
      if (query.data.listWorkTypes.nextToken) this.getWorkTypes(query.data.listWorkTypes.nextToken)
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users.push(data)
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
    //イベントの取得
    async getEvents(start, end, nextToken = null) {
      const query = await API.graphql(graphqlOperation(listEvents, {
        filter: {
          and: [
            { start: { ge: moment(start).subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss') } },
            { end: { le: moment(end).format('YYYY-MM-DDTHH:mm:ss') } },
          ],
        },
        limit: 100,
        nextToken: nextToken
      }))
      for (const data of query.data.listEvents.items) {
        this.events.push(data)
      }
      if (query.data.listEvents.nextToken) this.getEvents(start, end, query.data.listEvents.nextToken)
    },
    //労務・休憩時間の取得
    async getWorkTimeGroups(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTimeGroups, { limit: 100, nextToken: nextToken }))

      for (const data of query.data.listWorkTimeGroups.items) {
        const ret = await API.graphql(graphqlOperation(getWorkTimeGroup, { id: data.id }))
        const items = ret.data.getWorkTimeGroup.workTimes.items

        items.sort(function(a, b) {
          if (a.start < b.start) return -1
          if (a.start > b.start) return 1
        })
        data.workTimes = items

        this.worktimes.push(data)
      }
      if (query.data.listWorkTimeGroups.nextToken) {
        this.getWorkTimeGroups(query.data.listWorkTimeGroups.nextToken)
      }
    },
    /*
    //労務・休憩時間の取得
    async getWorkTimes(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTimes, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTimes.items) {
        this.worktimes.push(data)
      }
      if (query.data.listWorkTimes.nextToken) {
        this.getWorkTimes(query.data.listWorkTimes.nextToken)
        
      } else {
        this.worktimes.sort(function(a, b) {
          if (a.start < b.start) return -1
          if (a.start > b.start) return 1
        })
      }
    },
    */
  },
  components: {
    
  },
}
</script>

<style lang='scss' scoped>
#tree-view {
  height: calc(100vh - 180px);
  overflow-y: auto;
  font-size: 14px;
  .probated {
    color: #228200;
    display: inline-block;
    position: relative;
  }
  .probated:after {
    content: "承認済";
    background: #228200;
    color: #FFF;
    font-size: 12px;
    margin-left: 5px;
    padding: 1px 3px;
    border-radius: 3px;
  }
}
#detail-view {
  height: calc(100vh - 430px);
  overflow-y: auto;
}
.section-title {
  margin: 10px 0;
  padding: 5px 10px;
  font-weight: bold;
  background: #e1ecf3;
}
.data-table {
  tbody {
    tr th:first-of-type {
      width: 150px;
    }
    th, td {
      font-size: 14px !important;
      font-weight: normal !important;
    }
    ul {
      li {
        span {
          display: inline-block;
          &.project {
            width: 70px;
          }
          &.worktype {
            width: 120px;
          }
          &.time {
            width: 100px;
          }
        }
      }
    }
  }
}
@media screen and (max-width:600px) {
  #tree-view, #detail-view {
    height: auto;
  }
}
</style>
